import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { bool, func } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { pathOr } from 'ramda';

import {
  ModalSwimmy,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from '../../../components/ModalSwimmy';

import css from './LisitngPriceDetailsModal.css';
import { PriceBreakdown, PrimaryButton } from '../../../components';
import { CUSTOMER } from '../../../constants/booking';
import ExtraPanel from './ExtraPanel/ExtraPanel';
import { isNilOrEmpty } from '../../../util/validators';

const LisitngPriceDetailsModal = props => {
  const {
    selectedExtrasByListings,
    setSelectedExtrasByListings,
    intl,
    onManageDisableScrolling,
    onLisitngPriceDetailsModalClose,
    lisitngPriceDetailsModalOpen,
    listing,
    isPurchasingSwimPlus,
  } = props;
  const submitText = intl.formatMessage({ id: 'Marketplace.continue' });
  const paidExtrasData = pathOr([], ['attributes', 'publicData', 'paidExtrasData'], listing);
  const handleSaveExtras = (extras) => {
    setSelectedExtrasByListings(extras);
  };

  return (
    <ModalSwimmy
      id="LisitngPriceDetailsModal"
      isOpen={lisitngPriceDetailsModalOpen}
      onClose={onLisitngPriceDetailsModalClose}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <ModalOverlay/>
      <ModalContent className={css.modalContent}>
        {/*<ModalHeader className={css.modalHeader} heading={heading} />*/}
        <ModalCloseButton className={css.modalCloseButton} handleClose={onLisitngPriceDetailsModalClose}/>
        <ModalBody className={css.modalBody}>
          {!isNilOrEmpty(paidExtrasData) && (
            <ExtraPanel
              className={css.extraPanel}
              intl={intl}
              exposeSelectedExtras={handleSaveExtras}
              handleSubmit={handleSaveExtras}
              paidExtrasData={paidExtrasData}
              selectedExtrasByListings={selectedExtrasByListings}
              setSelectedExtrasByListings={setSelectedExtrasByListings}
              listingId={listing?.id?.uuid}
            />
          )}
          {isPurchasingSwimPlus && (
            <div className={css.swimPlus}>
              <h1 className={css.headingSwimPlus}>Swim +</h1>
              <span className={css.panelInfoSwimPlus}>{intl.formatMessage({id: 'CartPage.SwimPlusConfirmationTitle'})}</span>
            </div>
          )}
          {listing?.estimatedTransaction && (
            <PriceBreakdown
              className={css.priceBreakdown}
              transaction={listing.estimatedTransaction}
              userRole={CUSTOMER}
            />
          )}
          {!isNilOrEmpty(paidExtrasData) && !isNilOrEmpty(selectedExtrasByListings[listing?.id?.uuid]) && (
            <PrimaryButton className={css.submitButton} onClick={onLisitngPriceDetailsModalClose}>
              {submitText}
            </PrimaryButton>
          )}
        </ModalBody>
      </ModalContent>
    </ModalSwimmy>
  );
};

LisitngPriceDetailsModal.propTypes = {
  lisitngPriceDetailsModalOpen: bool,
  onLisitngPriceDetailsModalClose: func.isRequired,
  onManageDisableScrolling: func,
  intl: intlShape.isRequired,
};

export default injectIntl(LisitngPriceDetailsModal);
